import gql from 'graphql-tag';
import createQuery from './createQuery';

export default createQuery(gql`
  query getKeys ($domain:String!) {
    getKeys(domain: $domain)
  }
`);
